import { render, staticRenderFns } from "./AdminDesign.vue?vue&type=template&id=71e5253f"
import script from "./AdminDesign.vue?vue&type=script&lang=js"
export * from "./AdminDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports